import React from 'react';
import { Item, Stagger } from './Reveal';

// Adapted from Watermelon UI block "stats-1" (hatched cards with an oversized figure), using principles
// from the original About copy instead of invented metrics.
const principles = [
  {
    number: '01',
    label: 'Bespoke',
    title: 'Tailored, never templated',
    text: 'Every business is different. We start with your goals and build a strategy that fits — not a one-size-fits-all package.',
  },
  {
    number: '02',
    label: 'Innovation',
    title: 'Ahead of the curve',
    text: 'We embrace the latest trends and technologies in digital marketing, so your brand is always where your customers are.',
  },
  {
    number: '03',
    label: 'Commitment',
    title: 'Excellence, every time',
    text: 'Our unwavering commitment to quality and customer satisfaction is what sets us apart from the rest.',
  },
];

export default function Approach() {
  return (
    <section id="approach" className="bg-paper py-24 lg:py-32">
      <div className="mx-auto max-w-7xl px-5 sm:px-8 lg:px-12">
        <Stagger className="mx-auto max-w-2xl text-center">
          <Item as="p" className="eyebrow justify-center">Our approach</Item>
          <Item as="h2" className="mt-5 text-4xl font-normal leading-[1.05] tracking-[-0.045em] text-balance sm:text-5xl">
            What sets us <span className="font-serif italic tracking-[-0.02em] text-sage-deep">apart</span>
          </Item>
          <Item as="p" className="mt-5 text-ink-soft">
            Three commitments guide every partnership &mdash; from the first conversation to the results we deliver.
          </Item>
        </Stagger>

        <Stagger className="mt-14 grid gap-6 md:grid-cols-3">
          {principles.map((p) => (
            <Item
              key={p.number}
              className="hatch group flex flex-col rounded-[1.75rem] bg-paper-2 p-7 shadow-card transition-shadow duration-300 hover:shadow-card-hover"
            >
              <span className="inline-flex w-fit items-center rounded-xl border border-sage/30 bg-sage/10 px-3.5 py-2 text-[0.7rem] font-semibold uppercase tracking-[0.16em] text-sage-deep">
                {p.label}
              </span>
              <span className="mt-10 font-serif text-[5.5rem] leading-none tracking-[-0.04em] text-ink">
                {p.number}
              </span>
              <h3 className="mt-6 text-lg font-semibold tracking-[-0.02em]">{p.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-ink-soft">{p.text}</p>
            </Item>
          ))}
        </Stagger>
      </div>
    </section>
  );
}
